import { lazy, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type AttachmentsFilmstripView from './ui/filmstrip-view/index.tsx';
import type { FilmstripViewProps } from './ui/filmstrip-view/types.tsx';

export const AsyncAttachmentsFilmstripView: LazyComponent<
	(props: FilmstripViewProps) => React.JSX.Element | null
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazy<typeof AttachmentsFilmstripView>(() =>
		import(/* webpackChunkName: "async-jira-issue-field-attachments-filmstrip" */ './index').then(
			(module) => module.AttachmentsFilmstripView,
		),
	);
